"use client";

import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
type UseCountdownOptions = {
  onTick?: (remaining: number) => void;
  onComplete: () => void;
  finalZeroDelayMs?: number;
};
type UseCountdownReturn = {
  countdown: number | null;
  startCountdown: (from?: number) => boolean;
  cancelCountdown: () => void;
};
const DEFAULT_COUNTDOWN_SECONDS = 3;
const COUNTDOWN_INTERVAL_MS = 1000;
export function useCountdown(t0) {
  const $ = _c(18);
  const {
    onTick,
    onComplete,
    finalZeroDelayMs: t1
  } = t0;
  const finalZeroDelayMs = t1 === undefined ? 0 : t1;
  const [countdown, setCountdown] = useState(null);
  const timerRef = useRef(null);
  const isActiveRef = useRef(false);
  const onCompleteRef = useRef(onComplete);
  const onTickRef = useRef(onTick);
  let t2;
  if ($[0] !== onComplete || $[1] !== onTick) {
    t2 = () => {
      onCompleteRef.current = onComplete;
      onTickRef.current = onTick;
    };
    $[0] = onComplete;
    $[1] = onTick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const clearTimer = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = t5 => {
      const from = t5 === undefined ? DEFAULT_COUNTDOWN_SECONDS : t5;
      if (isActiveRef.current) {
        return false;
      }
      clearTimer();
      if (from <= 0) {
        setCountdown(null);
        onCompleteRef.current();
        return true;
      }
      isActiveRef.current = true;
      setCountdown(from);
      return true;
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const startCountdown = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      clearTimer();
      isActiveRef.current = false;
      setCountdown(null);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const cancelCountdown = t5;
  let t6;
  let t7;
  if ($[6] !== countdown || $[7] !== finalZeroDelayMs) {
    t6 = () => {
      if (countdown === null || countdown <= 0) {
        return;
      }
      onTickRef.current?.(countdown);
      timerRef.current = setTimeout(() => {
        if (countdown <= 1) {
          if (finalZeroDelayMs > 0) {
            setCountdown(0);
            return;
          }
          isActiveRef.current = false;
          setCountdown(null);
          onCompleteRef.current();
          return;
        }
        setCountdown(countdown - 1);
      }, COUNTDOWN_INTERVAL_MS);
      return clearTimer;
    };
    t7 = [clearTimer, countdown, finalZeroDelayMs];
    $[6] = countdown;
    $[7] = finalZeroDelayMs;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[10] !== countdown || $[11] !== finalZeroDelayMs) {
    t8 = () => {
      if (countdown !== 0 || finalZeroDelayMs <= 0) {
        return;
      }
      timerRef.current = setTimeout(() => {
        isActiveRef.current = false;
        setCountdown(null);
        onCompleteRef.current();
      }, finalZeroDelayMs);
      return clearTimer;
    };
    t9 = [clearTimer, countdown, finalZeroDelayMs];
    $[10] = countdown;
    $[11] = finalZeroDelayMs;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => clearTimer;
    t11 = [clearTimer];
    $[14] = t10;
    $[15] = t11;
  } else {
    t10 = $[14];
    t11 = $[15];
  }
  useEffect(t10, t11);
  let t12;
  if ($[16] !== countdown) {
    t12 = {
      countdown,
      startCountdown,
      cancelCountdown
    };
    $[16] = countdown;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}